var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({attrs:{"type":_vm.type,"icon":_vm.icon,"size":_vm.size},on:{"click":_vm.handleBack}},'el-button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }